jQuery(document).ready(function ($) {
    const header = $('.site-header');
    const header_items = header.find('.site-header__item');
    const header_toggle = header.find('.site-header__toggle');

    let toggle_running = false;

    function openHeaderDropdown(event) {
        header_items.removeClass('active');
        $('.site-header__dropdown').hide();

        $(this).addClass('active');
        $(this).find('.site-header__dropdown').show();
    }

    function closeHeaderDropdown(event) {
        $(this).removeClass('active');
        $(this).find('.site-header__dropdown').hide();

        /*
        setTimeout(function () {
            $(this).removeClass('active');
            $(this).find('.site-header__dropdown').hide();
        }.bind(this), 500);
        */
    }

    header_items.on({
        'mouseenter': openHeaderDropdown,
        'mouseleave': closeHeaderDropdown
    });

    function toggleNavMenu(event) {
        if (toggle_running) return;

        toggle_running = true;

        $(this).toggleClass('active');
        $(this).closest('.site-header').toggleClass('active');
        $('body').toggleClass('no-scroll');

        $('.mobile-menu').fadeToggle(500);

        toggle_running = false;
    }

    header_toggle.on('click', toggleNavMenu);

    function closeNavMenuOnResize (event) {
        if (toggle_running) return;

        if ($(this).width() <= 1024) return this;

        toggle_running = true;

        header_toggle.removeClass('active');
        header_toggle.closest('.site-header').removeClass('active');
        $('body').removeClass('no-scroll');

        $('.mobile-menu').fadeOut(500);

        toggle_running = false;
    }

    $(window).on('resize', closeNavMenuOnResize);

    $('.mobile-menu').on('click', function (event) {
        if ($(event.target).hasClass('mobile-menu')) {
            if (toggle_running) return;

            toggle_running = true;

            $(this).prev().find('.site-header__toggle').toggleClass('active');
            $(this).prev().toggleClass('active');
            $('body').toggleClass('no-scroll');

            $('.mobile-menu').fadeOut(500);

            toggle_running = false;
        }
    });
});